import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Login from "../src/pages/login";
import LoginPageoff from "../src/pages/login/indexoff";
import Home from "../src/pages/home";
import AgronomosV2 from "../src/pages/agronomos/indexV2.js";
import AddAgronomosV2 from "../src/pages/agronomos/addV2";
import EditAgronomosV2 from "../src/pages/agronomos/editV2.js";
import EditCrea from "./pages/agronomos/editCrea";
import EditCreaV2 from "./pages/agronomos/editCreaV2.js";
import AddCrea from "./components/creas/creas/addCrea";
import Arts from "../src/pages/arts";
import AddArts from "../src/pages/arts/add";
import EditArts from "../src/pages/arts/edit";
import EditContracts from "../src/pages/arts/specific";
import newContract from "../src/pages/arts/contracts";
import ContractLet from "../src/pages/arts/editContract";
import Devolucao from "./pages/devolucoes";
import AddDevolucao from "./pages/devolucoes/add";
import EditDevolucao from "../src/pages/devolucoes/edit";
import Filiais from "../src/pages/filiais";
import AddFiliais from "./pages/filiais/add";
import EditFiliais from "../src/pages/filiais/edit";
import AddProdutores from "../src/pages/produtores/add";
import EditProdutores from "../src/pages/produtores/edit";
import EditLocal from "../src/pages/produtores/editLocal";
import Fazendas from "../src/pages/produtores/indexlocal";
import AddLocal from "../src/pages/produtores/addlocal";
import AddReceitas from "../src/pages/receitas/add";
import AddReceitasLote from "../src/pages/receitas/addLote";
import Compendio from "../src/pages/compendio/index.js";
import Historico from "../src/pages/historico/index";
import AddUsers from "../src/pages/usuarios/add";
import EditUsers from "../src/pages/usuarios/edit";
import Users from "../src/pages/usuarios/index";
import NotFound from "../src/pages/404/index";
import Solicitar from "../src/pages/solicitar/index";
import Empresa from "../src/pages/filiais/indexEmpresa";
import Relatorios from '../src/pages/relatorio';
import Notificacao from "../src/pages/notificacao/index";
import Planos from "../src/pages/planos/index";
import TermosDeUso from "../src/pages/public-pages/termos-de-uso.js";
import PoliticaPrivacidade from "../src/pages/public-pages/politica-de-privacidade.js";
import DocSeguranca from "../src/pages/documentosSeg/index";
import SimulaPlanos from "../src/pages/planos/simulaPlanos.js";
import Simulacao from "../src/pages/planos/simulacao.js";
import Checkout from "../src/pages/checkout/index.js";
import CheckoutParceiros from "./pages/checkout/parceiros.js";
import CompendioGratis from "../src/pages/compendio/compendio-gratis";
import Compra from "../src/pages/compra";
import CompraSuccess from "../src/pages/compra/success";
import CadastroSite from '../src/pages/cadastro/site';
import CadastroFree from '../src/pages/cadastro/free';
import HelpNewReceita from '../src/pages/extras/new_prescription';
import ComprarReceitas from '../src/pages/compra/receita';
import ComprarLimite from '../src/pages/compra/limite';
import Faturamento from '../src/pages/faturamento';
import Integracao from '../src/pages/integracao';
import IntegracaoWebhook from '../src/pages/integracao/webhook.js';
import GuiaAplicacao from '../src/pages/guiaAplicacao';
import Blog from '../src/pages/blog';
import ValidacaoReceita from '../src/pages/receitas/validacao';
import EditarPlano from './pages/planos/edit.js';
import GerenciarPlano from './pages/gerenciar-plano/index.js';
import ReceituarioAgronomico from "./pages/receituario-agronomico/index.js";
import Apresentacao from "./pages/apresentacao/index.js";

import CupomIndique from "./pages/cupom-indique-e-ganhe"
import LpIndiqueGanhe from "./pages/indique-e-ganhe"
import ExportarDefesas from "./pages/exportar-defesas";
import ExportarDefesasDetails from "./pages/exportar-defesas/details";
import ExportarDefesasNfDetails from "./pages/exportar-defesas/details-nf";
import ExportarDefesasTrtDetails from "./pages/exportar-defesas/details-trt";
import ExportarDefesasRelatorioDetails from "./pages/exportar-defesas/details-relatorio";
import ExportarDefesasSpDetails from "./pages/exportar-defesas/details-sp";
import ExportarDefesasOrgaoDetails from "./pages/exportar-defesas/details-orgao";

//Telas 2.0
import NovoCadastro from "./pages/novo-cadastro/index.js";
import NovoCadastroCompleto from "./pages/novo-cadastro/complete-registration.js";
import NovoCadastroSucesso from "./pages/novo-cadastro/success.js";
import NovoCadastroEmail from "./pages/novo-cadastro-email/index.js";
import NovaSenha from "./pages/novo-cadastro/password.js";
import LoginSuccess from "./pages/login-success";


import NovaApresentacao from "./pages/home/apresentacao/index.js";
import NovaFarm from "./pages/nova-farm";
import NovoCalendario from "./pages/novo-calendario";

import { isAuthenticated } from "./services/auth";
import { upConfigRouteToNavbar } from "./services/conNavbar";

import produtoresV2 from "./pages/novo-produtores/index.js";

import CredenciaisDefesas from "./pages/totvs/credenciais-defesas/index.js";
import ConfigurarProdutos from "./pages/totvs/configurar-produtos/index.js";
import solicitacoesReceitas from "./pages/totvs/solicitacoes-receitas/index.js";
import NotasFiscais from "./pages/totvs/notas-fiscais/index.js";

import CheckoutSuccess from "./pages/checkout/success.js";

const PrivateRoute = ({ component: Component, isMobile, ...rest }) => {
  const [path, setPath] = useState('');
  const [mounted, setMounted] = useState(false);


  useEffect(() => {
    if (mounted === false) {
      setPath(rest.path)
      upConfigRouteToNavbar(rest)
      setMounted(true);
    }
  }, [mounted, rest])
  return (
    <>
      {mounted && path ? (
        <Route
          {...rest}

          render={props =>
            isAuthenticated() ? (
              <>
                {path && (
                  <>
                    {path !== rest.path ? (
                      <>
                        <Component {...props} isMobile={isMobile} config={rest} />
                      </>
                    ) : (
                      <Component {...props} isMobile={isMobile} config={rest} />
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {localStorage.setItem("lastAttemptedPath", window.location.href)}
                <Redirect
                  to={{ pathname: "/login", search: props.location.search, state: { from: props.location } }}
                />
                
              </>
            )
          }
        />
      ) : (null)}
    </>
  );
}

const Routes = ({ campaigns, ...props }) => (
  <Switch>
    <PrivateRoute exact path="/" component={Home} showMenu={true} prop={props} isMobile={props.isMobile} />
     {/* <PrivateRoute exact path="/agronomos" component={Agronomos} showMenu={true} prop={props} isMobile={props.isMobile} /> */}
    <PrivateRoute exact path="/agronomos" component={AgronomosV2} showMenu={true} prop={props} isMobile={props.isMobile} />
    {/* <PrivateRoute exact path="/agronomos/add" component={AddAgronomos} showMenu={true} prop={props} isMobile={props.isMobile} /> */}
    <PrivateRoute exact path="/agronomos/add" component={AddAgronomosV2} showMenu={true} prop={props} isMobile={props.isMobile} />
    {/* <PrivateRoute exact path="/agronomos/:id" component={EditAgronomos} showMenu={true} prop={props} isMobile={props.isMobile} />; */}
    <PrivateRoute exact path="/agronomos/:id" component={EditAgronomosV2} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/agronomos/edit/:id" component={EditCreaV2} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/arts" component={Arts} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/arts/add" component={AddArts} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/arts/:id" component={EditArts} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/creas/:id" component={EditCrea} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/creas/add/:id" component={AddCrea} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/compendio" component={Compendio} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/contracts/:id" component={EditContracts} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/compra/sucesso/" component={CompraSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/compra/sucesso/compra-5" component={CompraSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/compra/sucesso/compra-4" component={CompraSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/compra/sucesso/compra-7" component={CompraSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/compra/sucesso/compra-6" component={CompraSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/compra" component={Compra} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/devolucoes" component={Devolucao} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/devolucoes/add" component={AddDevolucao} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/devolucoes/:id" component={EditDevolucao} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/editcontract/:id" component={ContractLet} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/documentos_seguranca" component={DocSeguranca} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/empresa" component={Empresa} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/filiais" component={Filiais} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/filiais/add" component={AddFiliais} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/filiais/:id" component={EditFiliais} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/fazendas/edit/:idfazenda/:idprodutor" component={EditLocal} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/fazendas/:idfazenda/:idprodutor" component={NovaFarm} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/fazendas" component={Fazendas} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/historico" component={Historico} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/localdeaplicacao/add/:id" component={AddLocal} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/newcontract/:id" component={newContract} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/notificacao" component={Notificacao} showMenu={true} prop={props} isMobile={props.isMobile} />
    {/* <PrivateRoute exact path="/produtores" component={Produtores} showMenu={true} prop={props} isMobile={props.isMobile} /> */}
    <PrivateRoute exact path="/produtores" component={produtoresV2} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/produtores/add" component={AddProdutores} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/produtores/:id" component={EditProdutores} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/plano/edit" component={EditarPlano} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/gerenciar-plano" component={GerenciarPlano} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/receitas/add" component={AddReceitas} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/receitas/addlote" component={AddReceitasLote} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/receitas/add/?:culturaId/:pragaId/:produtoId/modoId" component={AddReceitas} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/relatorios" component={Relatorios} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/solicitar" component={Solicitar} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/usuarios/add" component={AddUsers} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/usuarios" component={Users} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/usuarios/:id" component={EditUsers} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/simulacao/:id" component={SimulaPlanos} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/extras/nova_receita" component={HelpNewReceita} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/comprar_receitas" component={ComprarReceitas} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/comprar_limite" component={ComprarLimite} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/faturamento" component={Faturamento} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/integracao" component={Integracao} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/integracao-webhook" component={IntegracaoWebhook} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/guia_aplicacao" component={GuiaAplicacao} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/blog" component={Blog} showMenu={true} prop={props} isMobile={props.isMobile} />
    {/* <PrivateRoute exact path="/crm" component={Crm} showMenu={true} prop={props} isMobile={props.isMobile} /> */}
    <PrivateRoute exact path="/cupom-indique-e-ganhe" component={CupomIndique} showMenu={true} prop={props} isMobile={props.isMobile} /> 
    <PrivateRoute exact path="/caderno-campo" component={NovoCalendario} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/nova-home/apresentacao" component={NovaApresentacao} showMenu={false} prop={props} isMobile={props.isMobile} />
    {/* <PrivateRoute exact path="/nova-home/apresentacao" component={TourSteps} showMenu={false} prop={props} isMobile={props.isMobile} /> */}
    <PrivateRoute exact path="/exportar-defesas" component={ExportarDefesas} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/exportar-defesas/nf/:uf" component={ExportarDefesasNfDetails} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/exportar-defesas/nacional" component={ExportarDefesasTrtDetails} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/exportar-defesas/relatorio/nf/:uf" component={ExportarDefesasRelatorioDetails} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/exportar-defesas/relatorio/:uf" component={ExportarDefesasRelatorioDetails} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/exportar-defesas/sp" component={ExportarDefesasSpDetails} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/exportar-defesas/orgao/:uf" component={ExportarDefesasOrgaoDetails} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/exportar-defesas/:uf" component={ExportarDefesasDetails} showMenu={true} prop={props} isMobile={props.isMobile} />


    {/* ROTAS TOTVS */}
    <PrivateRoute exact path="/solicitacoes-receitas" component={solicitacoesReceitas} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/credenciais-defesas" component={CredenciaisDefesas} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/configurar-produtos" component={ConfigurarProdutos} showMenu={true} prop={props} isMobile={props.isMobile} />
    <PrivateRoute exact path="/notas-fiscais" component={NotasFiscais} showMenu={true} prop={props} isMobile={props.isMobile} />
    {/* FIM ROTAS TOTVS */}

    <Route exact path="/checkout" component={Checkout} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/checkout/sucesso" component={CheckoutSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/checkout/parceiros" component={CheckoutParceiros} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/checkout/parceiros/sucesso" component={CheckoutSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/indique-e-ganhe" component={LpIndiqueGanhe} showMenu={false} prop={props} isMobile={props.isMobile} /> 
    <Route exact path="/compendio-gratis" component={CompendioGratis} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/cadastro" component={NovoCadastro} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/cadastro/site" component={CadastroSite} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/cadastro/free" component={CadastroFree} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/cadastro/sucesso" component={NovoCadastroSucesso} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/apresentacao" component={Apresentacao} showMenu={false} prop={props} isMobile={props.isMobile} />
    {/* <Route exact path="/senha/:ticket" search="/:ticket" component={Senha} showMenu={false} prop={props} isMobile={props.isMobile} /> */}
    <Route exact path="/validador" component={ValidacaoReceita} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/receituario-agronomico-2026" render={(routeProps) => <ReceituarioAgronomico {...routeProps} campaign={campaigns} showMenu={false} isMobile={props.isMobile} />} />
    <Route exact path="/lp-indique-e-ganhe" component={LpIndiqueGanhe} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/planos" render={(routeProps) => <Planos {...routeProps} campaign={campaigns} showMenu={false} isMobile={props.isMobile} />} />
    <Route exact path="/termos-de-uso" component={TermosDeUso} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/politica-de-privacidade" component={PoliticaPrivacidade} showMenu={false} prop={props} isMobile={props.isMobile} />
    {/* <Route exact path="/black-november-2024" component={BlackNovember2024} showMenu={false} prop={props} isMobile={props.isMobile} /> */}

    <Route path="/login-compra/:id" search="/:id" component={LoginPageoff} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route path="/login" component={Login} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/cadastro-completo" component={NovoCadastroCompleto} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/cadastro-email" component={NovoCadastroEmail} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route exact path="/abrir-app" component={LoginSuccess} showMenu={false} prop={props} isMobile={props.isMobile} />
    
    <Route exact path="/senha/:ticket" search="/:ticket"  component={NovaSenha} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route path="/simulacaoplano/:id" search="/:id" component={Simulacao} showMenu={false} prop={props} isMobile={props.isMobile} />
    <Route path="*" component={NotFound} showMenu={false} prop={props} isMobile={props.isMobile} />

  </Switch>
);


export default Routes;
